<template>
<div>
   <div v-for="tag  in ticketags" v-bind:key="tag.idTag"  style="margin: 2px">
    
      <div v-if="tag.Protected" style="border: 1px solid black;border-radius: 5px; padding: 3px;color:white;width: max-content;display: inline-block;background-color:red" ><small>PRIVATE</small></div>
      <div  style="border: 1px solid black;border-radius: 5px; padding: 3px;color:white;width: max-content;display: inline-block;"  v-bind:style="{ 'background-color' : tag.TagColour }"><small>{{tag.TagCategory}}</small></div>
      <div  style="border: 1px solid black;border-radius: 5px; padding: 3px;color:white;width: max-content;display: inline-block;"  v-bind:style="{ 'background-color' : tag.SubCatTagColour }"><small>{{tag.TagSubCategory}}</small></div>
      <div  v-if="tag.hasData" style="border: 1px solid black;border-radius: 5px; padding: 3px;color:white;width: max-content;display: inline-block;"  v-bind:style="{ 'background-color' : tag.SubCatTagColour }"><small>{{tag.valueAny}}</small></div>
       
      <div  style="border: 1px solid black;border-radius: 5px; padding: 3px;color:white;width: max-content;display: inline-block;"  v-bind:style="{ 'background-color' : tag.SubCatTagColour }"><small>{{tag.employee}}</small></div>
      <div  style="border: 1px solid black;border-radius: 5px; padding: 3px;color:white;width: max-content;display: inline-block;"  v-bind:style="{ 'background-color' : tag.SubCatTagColour }"><small>{{tag.ActualDate}}</small></div>
      <br>
    </div>
     
     <component-addtag :ticketid="ticketid" :idticketcomment="idticketcomment" :showadd="showadd"></component-addtag>
</div>
</template>

<script>
import addTicketTag from './addTicketTag.vue'
import axios from 'axios';
import moment from 'moment';

export default {
  props: ['ticketid','idticketcomment','showadd'],
  components: {
    'component-addtag' : addTicketTag
  },
  data() {
    return {
      hello: 'Hello World!',
     
      ticketags: []
    }
  }
  ,
   created: function () {
     
     var mainObject = this;
     //console.log(mainObject);
     axios.get(localStorage.getItem('ticketCopURL') +'/getTicketTags', {
          params: {
            idTicket : mainObject.ticketid,
            employee : localStorage.getItem('employee'),
            idTicketComment : mainObject.idticketcomment

          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          
          for( var i = 0 ; i < response.data.length ; i++ )
          {
              response.data[i].ActualDate = moment(response.data[i].ActualDate).format("YYYY-MM-DD");
              mainObject.ticketags.push(response.data[i]);

          }
          

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
           
          // always executed
          //console.log("Made request axios to get getTicketTags");
        });

   }
   , methods :  {
     refresh_data : function ()
      {
        
        console.log("refresh Data");
        var mainObject = this;
     //console.log(mainObject);
     axios.get(localStorage.getItem('ticketCopURL') +'/getTicketTags', {
          params: {
            idTicket : mainObject.ticketid,
            employee : localStorage.getItem('employee'),
            idTicketComment : mainObject.idticketcomment

          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          mainObject.ticketags = [];
          for( var i = 0 ; i < response.data.length ; i++ )
          {
             response.data[i].ActualDate = moment(response.data[i].ActualDate).format("YYYY-MM-DD");
            mainObject.ticketags.push(response.data[i]);

          }
          

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          console.log("Refreshed tag data");
        });  
      }
   }
}
</script>

